import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import './assets/css/App.css';

import App from './App';
import {Provider} from "react-redux";
import {store} from "./store/store.ts";


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    // <BrowserRouter>
    //   <App />
    // </BrowserRouter>,
    <StrictMode>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Provider store={store}>
                <App/>
            </Provider>
        </BrowserRouter>
    </StrictMode>,
);
